import { render, staticRenderFns } from "./AccreditationType.vue?vue&type=template&id=d2488044"
import script from "./AccreditationType.vue?vue&type=script&lang=js"
export * from "./AccreditationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports